import { ChevronDownIcon } from "@heroicons/react/24/outline";
import type { FAQ } from "../../../types/journey";
import styles from "./FaqItem.module.css";

export interface FaqItemProps {
	faq: FAQ;
	expanded: boolean;
	onToggle: (faqId: string) => void;
	expandLabel: string;
	collapseLabel: string;
}

export function FaqItem({
	faq,
	expanded,
	onToggle,
	expandLabel,
	collapseLabel,
}: FaqItemProps) {
	const panelId = `faq-panel-${faq.id}`;
	const buttonId = `faq-button-${faq.id}`;

	return (
		<div
			className={styles.row}
			data-expanded={expanded ? "true" : "false"}
			data-faq-id={faq.id}
		>
			<button
				type="button"
				id={buttonId}
				className={styles.header}
				aria-expanded={expanded}
				aria-controls={panelId}
				aria-label={expanded ? collapseLabel : expandLabel}
				onClick={() => onToggle(faq.id)}
			>
				<span className={styles.question}>{faq.question}</span>
				<ChevronDownIcon className={styles.chevron} aria-hidden="true" />
			</button>

			<section
				id={panelId}
				aria-labelledby={buttonId}
				aria-hidden={!expanded}
				hidden={!expanded}
				className={styles.answer}
			>
				{faq.answer}
			</section>
		</div>
	);
}
